import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { canEnterOperatorVendorDirectory, canManageAnyTags } from '@/store/vendorAccess';
import { canEnterTransfers } from '@/store/transferAccess';

const { Title, Text } = Typography;

interface Tile {
  key: string;
  title: string;
  description: string;
  to: string;
}

const QuickAccessTiles: React.FC = () => {
  const { authorization } = useAuthStore();
  const tiles: Tile[] = [];

  if (authorization?.globalAdmin) {
    tiles.push({
      key: 'vendors',
      title: 'Vendors',
      description: 'Open the vendor directory.',
      to: '/vendors',
    });
  } else if (canEnterOperatorVendorDirectory(authorization)) {
    tiles.push({
      key: 'vendors',
      title: 'Vendors',
      description: 'Open the vendors in your business units.',
      to: '/my-vendors',
    });
  }
  if (canEnterTransfers(authorization)) {
    tiles.push({
      key: 'transfers',
      title: 'Transfers',
      description: 'Review transfer activity.',
      to: '/transfers',
    });
  }
  if (authorization?.actions.includes('transfers.adhoc')) {
    tiles.push({
      key: 'ad-hoc',
      title: 'Ad Hoc Transfer',
      description: 'Start a one-time transfer.',
      to: '/transfers/ad-hoc',
    });
  }
  if (canManageAnyTags(authorization)) {
    tiles.push({
      key: 'tags',
      title: 'Tags',
      description: 'Add or remove vendor tags for your business unit.',
      to: '/settings/tags',
    });
  }
  if (authorization?.globalAdmin || authorization?.actions.includes('settings.manage')) {
    tiles.push({
      key: 'settings',
      title: 'Settings',
      description: 'Manage business unit settings.',
      to: '/settings/business-units',
    });
  }

  if (tiles.length === 0) {
    return null;
  }

  return (
    <Row gutter={[16, 16]}>
      {tiles.map((tile) => (
        <Col key={tile.key} xs={24} sm={12} lg={6}>
          <Link to={tile.to} style={{ display: 'block', color: 'inherit' }}>
            <Card hoverable>
              <Title level={4} style={{ marginTop: 0 }}>{tile.title}</Title>
              <Text type="secondary">{tile.description}</Text>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export default QuickAccessTiles;
